<template>
  <footer
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
    class="footer"
  >
    <h4 class="text-center description">
      地址：江苏省常州市钟楼区中吴大道1809号金翌大厦5层
    </h4>
    <h4 class="text-center description">
      商务电话：17327912973
    </h4>

    <div class="container">
      <nav>
        <ul>
          <li>
            <a href="#/">
              华龙科技
            </a>
          </li>
        </ul>
      </nav>

      <div class="copyright">
        &copy; {{ year }}, made with
        <md-icon>favorite</md-icon>
        by
        <a href="#/" target="_blank">华龙科技</a>
        for a better life.
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
